import LoyaltyPointTable from "./loyaltyPointHistoryTable.container"

export default LoyaltyPointTable
